export default __webpack_public_path__ + "assets/images/city-icon-new-2e7242c3.svg";